const styles = {

  contentContainer: {
    position: 'relative',
    backgroundColor: 'background.default',
    p: 2,
  },
  title: {
    '&.MuiTypography-root': {
      color: 'text.primaryDark',
      mt: 0,
    },
  },
  weightBold: {
    fontWeight: 'bold!important',
  },
  imageContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#000',
    p: { sm: 2 },
    '& > div': {
      width: { xs: '100%', sm: 300 },
      height: { xs: 248, sm: 180 },
    },
    '&.reverse': {
      paddingY: 2,
      paddingX: { xs: 2, lg: 0 },
      '& > div': {
        width: { xs: 290, sm: 380 },
        height: { xs: 460, sm: 350, lg: 350 },
      },
    },
    '&.isBigPhoto:not(.reverse)': {
      '& > div': {
        paddingY: 2,
        width: { xs: 220, sm: 220 },
        height: { xs: 270, sm: 297 },
      },
    },
  },

  backIcon: {
    position: 'absolute',
    top: '15px',
    left: '15px',
    zIndex: 10,
    backgroundColor: 'background.default',
    '&:hover': {
      backgroundColor: 'background.default',
    },
  },
}

export default styles
